import { render } from "./WcSearchFormPage.vue?vue&type=template&id=62fee86a"
import script from "./WcSearchFormPage.vue?vue&type=script&lang=js"
export * from "./WcSearchFormPage.vue?vue&type=script&lang=js"

import "./WcSearchFormPage.vue?vue&type=style&index=0&id=62fee86a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__